import React, { PropsWithChildren } from 'react';
import { VariantProps } from 'tailwind-variants';
import { dropdownStyle } from './styles';

interface IDropdownProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof dropdownStyle> {}

export function Dropdown({
  children,
  className,
  isOpened,
  position = 'top-right',
  ...rest
}: PropsWithChildren<IDropdownProps>) {
  return (
    <div
      className={dropdownStyle({
        position,
        isOpened,
        className,
      })}
      {...rest}
    >
      {children}
    </div>
  );
}
